import { Injectable } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { FormModalAction } from '../../apps/template-form-edit/form-modal-action.model';

@Injectable({ providedIn: 'root' })
export class PreventFormClosingService {
  canDeactivate(template: { modalReference: NgbModalRef | undefined }) {
    const isModalStillOpen = !!(template.modalReference as any)?._backdropCmptRef;
    return template.modalReference?.componentInstance && isModalStillOpen
      ? template.modalReference.componentInstance.beforeDismiss().then((shouldClose) => {
          if (shouldClose) {
            delete (template.modalReference as any).componentInstance;
            template.modalReference.close({ reason: FormModalAction.Close });
          }
          return shouldClose;
        })
      : true;
  }
}
